// extracted by mini-css-extract-plugin
export default {"button":"style__button___00Nvb","image":"style__image___KTD_z","label":"style__label___jN69G"};